module.exports = "/images/grid.png?6b70ad93585a881a024c32345664bd0f";